<template>
  <span>

    <v-card class="align-stretch" height="100%">
      <v-card-title>
        Enterprise
        <v-spacer></v-spacer>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="secondary" class="ml-2" x-small :href="queueUrl" target="_blank"><v-icon small>{{queueIcon}}</v-icon></v-btn>
          </template>
          <span>Provisioning Queue</span>
        </v-tooltip>

      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col>

            <p class="mb-1 text-caption">
              Supplier
              <template v-if="showSupplierEdit">
                <v-icon small @click="openSupplier">edit</v-icon>
              </template>
            </p>
            <template v-if="!supplierChange">
              <p><b>{{ supplier }}</b></p>
            </template>

            <template v-if="supplierChange">
              <div class="d-flex justify-start align-center mb-4">

                <v-select v-model="formData.supplier" :items="suppliers" :loading="getUpdateSupplierLoading" :disabled="getUpdateSupplierLoading" hide-details dense outlined />

                <div class="d-flex flex-column">
                  <v-icon color="secondary" @click="updateProductSupplier" :disabled="getUpdateSupplierLoading">check</v-icon>
                  <v-icon color="error" @click="supplierChange=false" :disabled="getUpdateSupplierLoading">close</v-icon>
                </div>

              </div>
            </template>

          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col>
            <template v-if="!mainNumberChange">
              <div class="mb-1">
                <span class="text-caption mr-1">Main Number</span>
                <InfoTooltip top>
                  The main phone number for the customer’s business
                </InfoTooltip>
                <v-icon small @click="openMainNumber()">edit</v-icon>
              </div>
              <p><b>{{mainNumber}}</b></p>
            </template>
            <template v-else>
              <div class="d-flex justify-start align-center mb-4">

                <div><v-select v-model="formData.mainNumber" :items="getProductNumbers" :disabled="getIsProductNumbersLoading||getIsMainNumberLoading" :loading="getIsProductNumbersLoading||getIsMainNumberLoading" label="Select main number" hide-details dense outlined /></div>

                <div><v-icon color="secondary" @click="__updateMainNumber" :disabled="getIsMainNumberLoading">check</v-icon></div>

                <div><v-icon color="error" @click="mainNumberChange=false;" :disabled="getIsMainNumberLoading">close</v-icon></div>

              </div>
            </template>
          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col>
            <template v-if="!serviceStatusChange">

              <p class="mb-1 text-caption">Service Status <v-icon small @click="openServiceStatus()">edit</v-icon></p>
              <p><b>{{serviceStatus}}</b></p>

            </template>
            <template v-else>
              <div class="d-flex justify-start align-center mb-4">

                <div><v-select v-model="formData.serviceStatus" :items="serviceStatusOptions" :disabled="getEnterpriseConfigurationLoading" :loading="getEnterpriseConfigurationLoading" label="Select service status" hide-details dense outlined /></div>

                <div><v-icon color="secondary" @click="__updateServiceStatus" :disabled="getEnterpriseConfigurationLoading">check</v-icon></div>

                <div><v-icon color="error" @click="serviceStatusChange=false;" :disabled="getEnterpriseConfigurationLoading">close</v-icon></div>

              </div>
            </template>
          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col>
            <template v-if="!internationalCallingChange">

              <p class="mb-1 text-caption">International Calling <v-icon small @click="openInternationalCallingChange()">edit</v-icon></p>
              <p><b>{{internationalCalling}}</b></p>

            </template>
            <template v-else>
              <div class="d-flex justify-start align-center mb-4">

                <div><v-select v-model="formData.internationalCalling" :items="intCallingSelect" :disabled="getEnterpriseConfigurationLoading" :loading="getEnterpriseConfigurationLoading" label="Select international calling" hide-details dense outlined /></div>

                <div><v-icon color="secondary" @click="__updateInternationalCalling" :disabled="getEnterpriseConfigurationLoading">check</v-icon></div>

                <div><v-icon color="error" @click="internationalCallingChange=false;" :disabled="getEnterpriseConfigurationLoading">close</v-icon></div>

              </div>
            </template>
          </v-col>
        </v-row>

        <v-row class="mt-n6">
          <v-col>
            <div class="mb-1">
              <span class="text-caption mr-1">Onboarding</span>
              <InfoTooltip top>
                Did the customer complete their onboarding session?
              </InfoTooltip>
            </div>
            <p><b>{{ onboarding }}</b></p>
          </v-col>

          <v-col v-if="supplier === 'VOIP3'">
            <div class="mb-1">
              <span class="text-caption mr-1">Instance</span>
            </div>
            <p><b>{{ getCurrentProduct.product_details.instance_display_name | customPlaceholder('-') }}</b></p>
          </v-col>
        </v-row>
        
      </v-card-text>
    </v-card>



  </span>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex';
  import InfoTooltip from '@/components/Base/InfoTooltip';
  import { mdiFormatListText } from '@mdi/js';

  export default {
    components: {
      InfoTooltip
    },

    data() {
      return {
        queue_url: process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`,
        queueUrl: '',
        queueIcon: mdiFormatListText,
        suppliers: [
          { text: 'VOIP3', value: 'VOIP3' },
          { text: 'Enreach', value: 'Centile' }
        ],
        serviceStatusOptions: [
          { text: 'Live', value: 'None' },
          { text: 'Blocked', value: 'AllOutgoingCalls' },
        ],
        intCallingSelect: [
          { text: "Enabled", value: false },
          { text: "Disabled", value: true }
        ],
        supplierChange: false,
        mainNumberChange: false,
        serviceStatusChange: false,
        internationalCallingChange: false,
        formData: {
          supplier: '',
          mainNumber: '',
          serviceStatus: '',
          internationalCalling: '',
        }
      }
    },

    created () {
      this.queueUrl = `${this.queue_url}voip-provisioning/actions/?site_id=${this.getCurrentProduct.id}`;
    },

    computed: {
      ...mapGetters('globals',['hasUserGotRole']),
      ...mapGetters('products',['getCurrentProduct','getCurrentVoipSite','getUpdateSupplierLoading', 'getUpdateSupplierError']),
      ...mapGetters('productGeneral',['getSelectedTariff','getSelectedPromo','getSelectedAddon','getProductNumbers','getIsProductNumbersLoading','getIsMainNumberLoading','getMainNumberError']),
      ...mapGetters("enterpriseConfiguration", ["getEnterpriseConfiguration", "getEnterpriseConfigurationLoading",'getEnterpriseConfigurationError','getHasInternationalCallsInEdit','getInternationalCallsCanEditStatus','getHasPlatformId','getHasNoEnterprise']),

      serviceStatus(){
        if(this.getEnterpriseConfigurationLoading){ return '-'; }
        if(this.getCurrentProduct.product_details.platform_id===null){ return 'Not Yet Provisioned'; }
        if(this.getHasNoEnterprise){ return '-'; }
        return this.getEnterpriseConfiguration.call_restriction==='AllOutgoingCalls' ? 'Blocked' : 'Live';
      },

      internationalCalling(){
        if(this.getEnterpriseConfigurationLoading){ return '-'; }
        const notProvisioned = this.getCurrentVoipSite.platform_id===null;
        const addons = this.getSelectedAddon(this.getCurrentProduct);
        const intCallAddonIds = [358,359,369,35,99,102,103,122];
        const hasIntAddon = addons.filter(e=>intCallAddonIds.includes(e.id)).length;
        if(notProvisioned && hasIntAddon>0){ return 'Included'; }

        const intCall = this.getEnterpriseConfiguration.international_call_barring;
        if(this.getHasNoEnterprise && hasIntAddon>0){ return 'Included'; }
        if(this.getHasNoEnterprise && notProvisioned){ return 'Not Yet Provisioned'; }
        if(this.getHasNoEnterprise){ return '-'; }
        return intCall ? 'Disabled' : 'Enabled';
      },

      mainNumber(){
        const pilot = this.getCurrentProduct.product_details.pilot_number;
        return pilot ? pilot.number ? pilot.number : '-' : '-';
      },

      disabledIfNotLive(){
        const statuses = ['warm','for approval'];
        const prodStatus = this.getCurrentProduct.status.toLowerCase();
        return !statuses.includes(prodStatus);
      },

      onboarding() {
        switch(this.getCurrentVoipSite.onboarding) {
          case 'COMPLETED':
            return 'Completed'
          case 'NOT_COMPLETED':
            return 'Not Completed'
          case 'SCHEDULED':
            return 'Scheduled'
          case 'MISSED_APPOINTMENT':
            return 'Missed Appointment'
          default:
            return '-'
        }
      },

      supplier() {
        if (this.getCurrentProduct.supplier === 'Centile') {
          return 'Enreach';
        }

        return this.getCurrentProduct.supplier;
      },

      showSupplierEdit() {
        return !this.supplierChange && this.getCurrentProduct.status === 'Warm' && this.hasUserGotRole('can-convert-voip-leads-to-voip3');
      }
    },

    methods: {
      ...mapActions('productGeneral', ['fetchNumbers','updateMainNumber']),
      ...mapActions('enterpriseConfiguration', ['updateEnterpriseConfiguration']),
      ...mapActions('alerts', ['setAlert']),
      ...mapActions('products', ['updateSupplier']),

      openSupplier() {
        this.supplierChange = true;
        this.formData.supplier = this.getCurrentProduct.supplier;
      },

      async openMainNumber() {
        this.mainNumberChange = true;
        await this.fetchNumbers(this.getCurrentProduct);
        const selectedNumber = this.getProductNumbers.filter(e=>e.text===this.mainNumber);
        this.formData.mainNumber = selectedNumber[0] ? selectedNumber[0].value : '';
      },

      async openServiceStatus() {
        if(this.getCurrentVoipSite.platform_id===null){
          this.setAlert({type: 'error', message: `Cannot change service status, product not yet provisioned`});

        }else if(this.getHasNoEnterprise){
          this.setAlert({type: 'error', message: `Cannot change service status, cannot find VoIP service`});

        }else if(!this.hasUserGotRole('can-change-voip-service-status')){
          this.setAlert({type: 'error', message: `You do not have permission to change the service status`});

        }else{
          this.formData.serviceStatus = this.getEnterpriseConfiguration.call_restriction;
          this.serviceStatusChange = true;
        }
      },

      async openInternationalCallingChange() {
        if(this.getCurrentVoipSite.platform_id===null){
          this.setAlert({type: 'error', message: `Cannot change international calling, product not yet provisioned`});

        }else if(this.getHasNoEnterprise){
          this.setAlert({type: 'error', message: `Cannot change international calling, cannot find VoIP service`});

        }else{
          this.formData.serviceStatus = this.getEnterpriseConfiguration.call_restriction;
          this.internationalCallingChange = true;
        }
      },

      async runUpdateMainNumber(){
        const data = {
          product_id: this.getCurrentProduct.id,
          number: this.formData.mainNumber
        };
        await this.updateMainNumber(data);
        if(!this.getMainNumberError){
          this.mainNumberChange = false;
          setTimeout(()=>{
            window.location.reload();
          },500);
        }
      },

      async __updateMainNumber() {
        if(this.formData.mainNumber!==this.mainNumber){
          if(!['Warm','For Approval','Verification'].includes(this.getCurrentProduct.status)){
            const newNumber = this.getProductNumbers.filter(e=>e.value===this.formData.mainNumber);
            if(confirm(`The customer’s main number will be changed from ${this.mainNumber} to ${newNumber[0].text}. Are you sure you want to proceed?`)){
              this.runUpdateMainNumber();
            }
            
          }else{
            this.runUpdateMainNumber();
          }
        }
      },

      async __updateServiceStatus() {
        const data = {
          id: this.getCurrentProduct.id,
          data: {call_restriction: this.formData.serviceStatus}
        };
        await this.updateEnterpriseConfiguration(data);
        if(!this.getEnterpriseConfigurationError){
          this.serviceStatusChange = false;
          setTimeout(()=>{
            window.location.reload();
          },500);
        }
      },

      async __updateInternationalCalling() {
        const data = {
          id: this.getCurrentProduct.id,
          data: {international_call_barring: this.formData.internationalCalling}
        };
        await this.updateEnterpriseConfiguration(data);
        if(!this.getEnterpriseConfigurationError){
          this.internationalCallingChange = false;
          setTimeout(()=>{
            window.location.reload();
          },500);
        }
      },

      async updateProductSupplier() {
        await this.updateSupplier({product_id: this.getCurrentProduct.id, supplier: this.formData.supplier});

        if (!this.getUpdateSupplierError) {
          this.supplierChange = false;
          setTimeout(()=>{
            window.location.reload();
          },500);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
